import type { Panel } from '@/types/panels'

export const navigateToPanel = (panel: Panel): void => {
  window.location.href = `/panels/${panel.id}`
}

export const navigateToProductSearch = (productName: string): void => {
  if (productName.trim()) {
    window.location.href = `/panels?name_search=${encodeURIComponent(productName)}`
  }
}

export const navigateToSectionModulusSearch = (
  sectionModulus: string,
  unit: 'metric' | 'imperial',
): void => {
  if (sectionModulus.trim()) {
    const units = unit === 'imperial' ? 'i' : 'm'
    window.location.href = `/panels?selected_measure=section_modulus_per_width&min_value=${encodeURIComponent(
      sectionModulus,
    )}&units=${units}`
  }
}

export const navigateToBendingMomentSearch = (unit: 'metric' | 'imperial'): void => {
  const units = unit === 'imperial' ? 'i' : 'm'
  window.location.href = `/panels?units=${units}`
}
